import { createContext, useContext } from "react";
import { empresasService } from "app/services";
import { useQuery } from "@tanstack/react-query";
import { useQueryParams } from "app/hooks";

const EmpresasContext = createContext();

const initialSearchParams = {};

export function EmpresasProvider({ children }) {
  const { queryParams, setQueryParams } = useQueryParams();

  const empresasQuery = useQuery({
    queryKey: ["empresas:get:empresas", queryParams],
    queryFn: () => empresasService.getEmpresas({ params: queryParams }),
  });

  function paramsReset() {
    // setQueryParams(initialSearchParams);
  }

  return (
    <EmpresasContext.Provider
      value={{
        data: empresasQuery.data,
        isLoading: empresasQuery.isLoading,
        isFetching: empresasQuery.isFetching,
        refetch: empresasQuery.refetch,
        isRefetching: empresasQuery.isRefetching,
        queryParams,
        setQueryParams,
        paramsReset,
      }}
    >
      {children}
    </EmpresasContext.Provider>
  );
}

export function useEmpresasContext() {
  const empresasContext = useContext(EmpresasContext);

  if (!empresasContext) {
    throw new Error(
      "useEmpresasContext should be used inside the EmpresasProvider."
    );
  }

  return empresasContext;
}
